<template>
  <div class="credit order">
    <div class="authentication">
    <van-nav-bar
      fixed
      @click-left="goBack"
      @click-right="$router.push({ path: '/CreditApply' })"
    >
      <template #right>
        <span style="color: #4385F5">申请</span>
      </template>
    </van-nav-bar>
    <div class="frame-content">
      <slot />
    </div>
  </div>
    <div class="credit-hd">
      <van-row>
        <van-col span="12">
          <div class="title">可用总余额</div>
          <div class="desc">{{money | pricesFormat('￥')}}</div>
        </van-col>
        <van-col span="12">
          <div class="title">已锁定余额</div>
          <div class="desc">{{lock_money | pricesFormat('￥')}}</div>
        </van-col>
      </van-row>
    </div>
    <div class="cont">
      <van-tabs v-model="active">
        <van-tab title="授信记录">
          <!-- 授信记录列表页 -->
          <CreditList/>
        </van-tab>
        <van-tab title="支出流水">
          <!-- 支出流水列表页 -->
          <CreditExpList/>
        </van-tab>
        <van-tab title="" disabled></van-tab>
        <van-tab title="" disabled></van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import AppFrame from '@/components/AppFrame'
import CreditList from '../../components/List/CreditList'
import CreditExpList from '../../components/List/CreditExpList'
export default {
  name: "Credit",
  components: {
    AppFrame,
    CreditList,
    CreditExpList
  },
  data() {
    return {
      svalue: '',
      active: 0,
      money: 0,
      lock_money: 0,
      loading:false,
    };
  },
  created() {
    this.getCanUserMoney()
  },
  methods: {
    // 请求数据
    getCanUserMoney () {
      // this.$toast.loading({
      //   message: '加载中...',
      //   forbidClick: true,
      // });
      this.$api.apis.getCanUserMoney({}).then(res => {
        if(res&&res.rsObj&&res.rsObj.fundAccount){
          this.money = res.rsObj.fundAccount.money
          this.lock_money = res.rsObj.fundAccount.lock_money
        }
        // this.$toast.clear()
      }).catch(err => {
        this.$toast(err.msg)
      });
    },
    goBack() {
      const path = this.$route.path
      if (window.history.length <= 1) {
          if(window.ReactNativeWebView)window.ReactNativeWebView.postMessage(JSON.stringify({type:4,msg:'返回上一页'}));
          return false
      } else {
          this.$router.go(-1)
      }
      setTimeout(() => {
        if (path === this.$route.path) {
          this.$webview.notice('CLOSE_WEBVIEW')
        }
      }, 100)
    }
  },
  filters: {
    pricesFormat : (value,roul) => {
      if(!value) return '--'
      return roul + value
    }
  },
  destroyed() {
  }
};
</script>
<style scoped lang="less">
  @import '../../styles/credit.less';
</style>



// WEBPACK FOOTER //
// src/pages/Credit/index.vue